import ztComponent from './ztInputFile.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
